<template>
  <div class="directions">
    <div class="directions__content">
      <h2>{{ title }}</h2>
      <div class="directions__list">
        <div
          v-for="advantage in advantages"
          :key="advantage.id"
          class="directions__list-item"
        >
          <VIconMTS
            :name="'faq/' + advantage.iconName"
            width="60"
            height="60"
          />
          <h3>{{ advantage.title }}</h3>
          <p v-html="advantage.text"></p>
        </div>
        <div class="statistics-card">
          <div class="statistics-card__item">
            <span>92%</span>
            <p>удовлетворённость пользователей техподдержкой МТС&nbsp;Линк</p>
          </div>
          <div class="statistics-card__item">
            <span>80%</span>
            <p>вопросов решаем при&nbsp;первом обращении</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VIconMTS from '@/components/Common/MTS/VIconMTS.vue'
import FaqAndSupportAdvantageListMixin from '@/components/Desktop/FaqAndSupport/mixins/FaqAndSupportAdvantageListMixin'

export default {
  name: 'FaqAndSupportDirectionsMobile',
  components: { VIconMTS },
  mixins: [FaqAndSupportAdvantageListMixin],
}
</script>

<style scoped lang="scss">
.directions {
  padding-bottom: 32px;

  &__content {
    padding: 32px 20px;
    border-radius: 24px;
    background-color: $color-white;
  }

  h2 {
    margin-bottom: 16px;
    font-family: $font-mts-wide;
    font-size: 32px;
    line-height: 38px;
    font-weight: 500;
    letter-spacing: -0.01em;
    text-align: center;
  }

  &__list {
    display: flex;
    flex-direction: column;
    margin-top: 56px;
  }

  &__list-item {
    padding: 24px;

    h3 {
      margin: 12px 0 16px;
      font-family: $font-mts-wide;
      font-size: 24px;
      line-height: 30px;
      font-weight: 500;
      letter-spacing: -0.01em;
    }

    p {
      max-width: 600px;
      font-size: 18px;
      line-height: 24px;
    }
  }

  .statistics-card {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
    padding: 24px;
    margin-top: 20px;
    border-radius: 24px;
    background-color: #f6eeff;

    &__item {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;

      span {
        font-family: $font-mts-wide;
        font-size: 34px;
        line-height: 34px;
        font-weight: 500;
        color: $color-purple-2;
      }

      p {
        max-width: 394px;
        font-size: 20px;
        line-height: 27px;
      }
    }
  }
}
</style>
